import React, {useEffect, useRef, useState} from "react";
import { Range } from 'react-range';
import { distributionItems } from "../../data/distributionItems";
import "./Prices.css";
import {useTranslation} from "react-i18next";
import i18n from "../../texts/i18n";
import {capitalize} from "../../utils";

const countries = ['Brazil', 'UAE', 'India', 'USA'];


export const Prices = () => {
    const [currentPriceItem, setCurrentPriceItem] = React.useState(distributionItems[0]);
    const [currentCountryItem, setCurrentCountryItem] = React.useState(countries[3]);
    const [values, setValues] = React.useState([0]);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 900);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const { t } = useTranslation();
    const isInternationalVersion = i18n.options.fallbackLng.length === 1;
    //const isInternationalVersion = true;
    const fieldForShowedPrice = isInternationalVersion ? 'priceUSD' : 'price';
    const showedPriceOfOneItem = values[0] <= currentPriceItem.priceItems[0].max ?
        currentPriceItem.priceItems[0][fieldForShowedPrice] :
        (values[0] <= currentPriceItem.priceItems[1].max ? currentPriceItem.priceItems[1][fieldForShowedPrice] : currentPriceItem.priceItems[2][fieldForShowedPrice]);
    const showedPrice = Math.round(values[0] * showedPriceOfOneItem);
    return (
        <div className={'pricePage'}>
            <div className={'priceHeader'}>{capitalize(t('pages.pricing'))}</div>
            <div className={'priceMainBlock'}>
                <div className={'pricesItems'}>
                    {distributionItems.map((item, index) => (
                        <div key={index} className={currentPriceItem.id === item.id ? 'selectedPriceItem' : 'priceItem'} onClick={() => {setCurrentPriceItem(item); setValues([0])}}>{item[t("prices.titleField")]}</div>
                    ))}
                </div>
                {
                    currentPriceItem.id === 2 && isInternationalVersion &&
                    <div className={'countryItems'}>
                        {countries.map((item, index) => <div key={index} className={currentCountryItem === item ? 'selectedPriceItem' : 'priceItem'} onClick={() => {setCurrentCountryItem(item)}}>{item}</div>)}
                    </div>
                }
                <div className={'priceItemHeaderContainer'}>
                {/*<div className={'priceItemHeaderDesktop'}>{t("services.channelInfoShort")} {currentPriceItem[t("prices.titleField")]}</div>*/}
                <div className={'priceFormat'}>{currentPriceItem[t("prices.formatField")]}</div>
                </div>
                {
                    isMobile ? (
                        <div className="tableMobile">
                            <div className="tableMobileRow">
                                <div className="tableMobileCell tableMobileCellHead">{t('prices.amount')}</div>
                                <div className="tableMobileCell tableMobileCellHead">{isInternationalVersion ? t('prices.priceUSD') : t('prices.price')}</div>
                            </div>
                            <div className="tableMobileRow">
                                <div className="tableMobileCell tableMobileCellLeft">{`${currentPriceItem.priceItems[0].min} - ${currentPriceItem.priceItems[0].max}`}</div>
                                <div className="tableMobileCell tableMobileCellRight">{`${isInternationalVersion ? currentPriceItem.priceItems[0].priceUSD : currentPriceItem.priceItems[0].price}`}</div>
                            </div>
                            <div className="tableMobileRow">
                                <div className="tableMobileCell tableMobileCellLeft">{`${currentPriceItem.priceItems[1].min} - ${currentPriceItem.priceItems[1].max}`}</div>
                                <div className="tableMobileCell tableMobileCellRight">{`${isInternationalVersion ? currentPriceItem.priceItems[1].priceUSD : currentPriceItem.priceItems[1].price}`}</div>
                            </div>
                            <div className="tableMobileRow">
                                <div className="tableMobileCell tableMobileCellLeft">{`${currentPriceItem.priceItems[2].min} - ${currentPriceItem.priceItems[2].max}`}</div>
                                <div className="tableMobileCell tableMobileCellRight">{`${isInternationalVersion ? currentPriceItem.priceItems[2].priceUSD : currentPriceItem.priceItems[2].price}`}</div>
                            </div>
                        </div>
                    ) : (
                        <div className="ptable">
                            <div className="prow prowup">
                                <div className="pcell pcellleft pcellup">{t('prices.amount')}</div>
                                {currentPriceItem.priceItems.map((item, index) => <div key={index} className="pcell pcellhead pcellup">{item.min} - {item.max}</div>)}
                            </div>
                            <div className="prow prowdown">
                                <div className="pcellprice pcell pcellleft pcelldown">{isInternationalVersion ? t('prices.priceUSD') : t('prices.price')}</div>
                                {currentPriceItem.priceItems.map((item, index) => <div key={index} className="pcell pcellmain pcelldown">{isInternationalVersion ? item.priceUSD : item.price}</div>)}
                            </div>
                        </div>
                    )
                }


                <div className={'priceRangeContainer'}>
                    <div className={'priceRange'}>
                        <Range
                            step={1000}
                            min={0}
                            max={currentPriceItem.priceItems[2].max}
                            values={values}
                            onChange={(values) => setValues(values)}
                            renderTrack={({ props, children }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...props.style,
                                        height: '6px',
                                        width: '100%',
                                        backgroundColor: '#268DFF'
                                    }}
                                >
                                    {children}
                                </div>
                            )}
                            renderThumb={({ props }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...props.style,
                                        height: '24px',
                                        width: '24px',
                                        backgroundColor: '#268DFF',
                                        border: 'none',
                                        borderRadius: '50%',
                                    }}
                                />
                            )}
                        />
                    </div>

                    <div className={'priceInfo'}>
                        <div className={'priceInfoEmpty'}>{t('prices.emptyText')}</div>
                        <div className={'priceInfoRight'}>
                            <div className={'priceInfoRightInfo'}>
                                <div className={'priceInfoItem'}>{values} {t('prices.pcs')}</div>
                                <div className={'priceInfoItem'}>{showedPrice} {isInternationalVersion ? t('prices.dollars') : t('prices.rubles')}</div>
                            </div>
                            <button
                                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                className="belowSliderButtonPr"
                            >
                                <div className="blockGeneratorContentGenerateButtonText">{t('formbutton')}</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};